import { render, staticRenderFns } from "./FacilityTeam.vue?vue&type=template&id=710357c0&scoped=true"
import script from "./FacilityTeam.vue?vue&type=script&lang=js"
export * from "./FacilityTeam.vue?vue&type=script&lang=js"
import style0 from "./FacilityTeam.vue?vue&type=style&index=0&id=710357c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710357c0",
  null
  
)

export default component.exports